import { AntDesign } from "@expo/vector-icons";
import React from "react";

import ExchangeIcon from "@/assets/exchangeicon.svg";

export function checkMobileTransferIcon(type: string) {
  switch (type) {
    case "FIAT_TRANSFER_IN":
      return <AntDesign name="arrowdown" size={24} color="#BDBDBD" />;
    case "FIAT_TRANSFER_OUT":
      return <AntDesign name="arrowup" size={24} color="#BDBDBD" />;
    case "TRADE":
      return <ExchangeIcon style={{ width: 24, height: 24 }} />;
    default:
      return <AntDesign name="arrowup" size={24} color="#BDBDBD" />;
  }
}
